import { Link } from "react-router-dom";
import React from "react";
import { useGuildPath } from "../../../utils/Guild/useGuild";
import { openCookiePreferences } from "../../../utils/Tracking/consent";
import {
  useScreenerLoggedIn,
  setDisplayScreenerLogin,
  setDisplayScreenerProjectList,
} from "../../../utils/Screeners/useScreeners";

export default function FooterMeta() {
  const guildPath = useGuildPath();
  const screenerLoggedIn = useScreenerLoggedIn();
  return (
    <div
      className={
        "page-sink-identity align-items-start align-items-lg-start justify-content-start justify-content-lg-end"
      }
    >
      <div className="page-identity">
        <Link to={guildPath("/")} className="">
          <img
            src="/img/netflix-logo-ribbon.png"
            alt="NF"
            className="page-logo"
          />
        </Link>
        <Link to={guildPath("/")} className="page-identity-copy">
          <div className="page-identity-title">Series</div>
          <div className="page-identity-subtitle d-none d-sm-block">
            For Your Consideration
          </div>
          <div className="page-identity-subtitle d-block d-sm-none">FYC</div>
        </Link>
      </div>
      <div className={"page-sink-nav"}>
        <Link to={guildPath("/")}>Home</Link>
        <Link to={"/events"}>Events</Link>
        <Link
          to={"/"}
          onClick={(e) => {
            e.preventDefault();
            if (screenerLoggedIn) {
              setDisplayScreenerProjectList(true);
            } else {
              setDisplayScreenerLogin(true);
            }
          }}
        >
          Screeners
        </Link>
      </div>
      <div className={"page-sink-nav flex-column"}>
        <Link to={"/privacy-and-terms"}>Privacy and Terms</Link>
        <Link to={"/do-not-sell-or-share"}>
          Do Not Sell or Share My Personal Information
        </Link>
        <Link to={"mailto:fysee@netflix.com"} target={"_blank"}>
          fysee@netflix.com
        </Link>
        {/* Opens the OneTrust preference centre; the Do Not Sell page tells
            users to look for this link in the footer */}
        <a
          href="#cookie-preferences"
          onClick={(e) => {
            e.preventDefault();
            openCookiePreferences();
          }}
        >
          Cookie Preferences
        </a>
      </div>
      <div className={"page-sink-social"}>
        <div>
          <a
            href="https://www.instagram.com/netflix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={"/img/ico/ig.png"} alt={"Instagram"} />
          </a>
        </div>
        <div>
          <a
            href="https://www.facebook.com/netflix"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={"/img/ico/fb.png"} alt={"Facebook"} />
          </a>
        </div>
      </div>

      <div className={"page-sink-legal"}>
        All uses of the Netflix For Your Consideration Website are subject to
        the terms of use associated with your promotional code and the{" "}
        <Link to="/privacy-and-terms">Privacy and Terms</Link>
      </div>
    </div>
  );
}
